import CheckIcon from '@mui/icons-material/Check';
import { joinWithAnd } from '../../../utils/joinWithAnd';
import { DEFAULT_ADVANCE_BUTTON_STYLE } from '../../../utils/styleHelpers';
import { Icon } from '../../Atoms/Icon';
import { TextBlock } from '../../Atoms/Text';
import { ComponentSpinner } from '../../Compounds/Loading/ComponentSpinner';
import { ScorerForm, ScorerHeaderBand, ScorerNotice } from '../../Compounds/Advise/Scorer';
import { ScorerProblem, useScorer } from './useScorer';

// None of these names the engagement or the supplier: a stranger holding a bad link learns nothing.
const PROBLEM_MESSAGES: Record<ScorerProblem, string> = {
  expired: 'This scoring link has expired.',
  superseded: 'A newer link was sent to you. Please use the most recent email.',
  revoked: 'This scoring request is no longer active.',
  invalid: "This link isn't valid.",
  failed: 'Something went wrong.'
};

/** The public page an invitee opens from their emailed link to score one supplier, with no Portal login. */
export const ScorerPage = () => {
  const scorer = useScorer();
  const { state, retry } = scorer;

  return (
    <div className="min-h-screen bg-main-300">
      <title>Secure Scoring Request</title>
      <ScorerHeaderBand showsSecureLine={state.kind === 'open'} />
      <main className="mx-auto flex max-w-[700px] flex-col gap-4 px-4 py-8">
        {state.kind === 'loading' && <ComponentSpinner />}
        {state.kind === 'open' && (
          <ScorerForm
            view={state.view}
            ratings={scorer.ratings}
            comment={scorer.comment}
            saveFailed={scorer.saveFailed}
            submitting={scorer.submitting}
            submitRefusal={scorer.submitRefusal}
            onRate={scorer.rate}
            onCommentChange={scorer.changeComment}
            onSubmit={scorer.submit}
          />
        )}
        {state.kind === 'completed' && (
          <ScorerNotice
            icon={<CheckIcon sx={{ fontSize: 40, color: 'success.main' }} />}
            title="Thanks — your scores are in.">
            <TextBlock
              size="sm14"
              color="grey6"
              className="max-w-md">
              Your {joinWithAnd(state.confirmation.categories.map((category) => category.label))} scores for{' '}
              {state.confirmation.supplier.supplier_name} have been sent to your UPSTACK Advisor. You can close this
              page.
            </TextBlock>
          </ScorerNotice>
        )}
        {state.kind === 'problem' && (
          <ScorerNotice
            icon={
              <Icon
                type="alert"
                className="h-10 w-10"
              />
            }
            title={PROBLEM_MESSAGES[state.problem]}>
            {state.problem === 'failed' && (
              <button
                type="button"
                className={DEFAULT_ADVANCE_BUTTON_STYLE}
                onClick={retry}>
                Try Again
              </button>
            )}
          </ScorerNotice>
        )}
        <TextBlock
          size="sm"
          color="grey6"
          className="text-center">
          This link is unique to you.
        </TextBlock>
      </main>
    </div>
  );
};
